/**
 * Which zones can be played right now (user, 2026-10-10: only the starting map, ลานศิลาเก้ากระบี่).
 * Every other zone stays in `zones.ts` untouched; to open one again, add its id to this list.
 * Saves in a closed zone land in the hub, warp circles to a closed zone are not made, and any
 * other way there (carriage, guide) says the area is closed.
 */
import { SECT_TABLE } from './layouts/sects';
import { CITY_TABLE } from './layouts/cities';
import { HUB, type ZoneId } from './zones';

export const ENABLED_ZONES: readonly ZoneId[] = ['plains', 'town-b', 'town-c', 'town-d', ...SECT_TABLE.map((r) => `sect-${r.id}` as ZoneId), ...CITY_TABLE.map((r) => `city-${r.id}` as ZoneId)];

/** Tests only (test/setup.ts opens every zone, enabledZones.test.ts checks the switch): `null` = the list above. */
let override: readonly ZoneId[] | 'all' | null = null;
export const overrideEnabledZones = (v: readonly ZoneId[] | 'all' | null): void => {
  override = v;
};

export const zoneEnabled = (id: ZoneId): boolean =>
  override === 'all' ? true : (override ?? ENABLED_ZONES).includes(id);

/** The zone to play in: `id` if open, else the hub. */
export const openZone = (id: ZoneId): ZoneId => (zoneEnabled(id) ? id : HUB);

/** Said when something sends the player to a closed zone. */
export const CLOSED_NOTICE = 'พื้นที่นี้ยังปิดอยู่';
